import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { AssignDriverEntity } from '../../domain/entities/AssignDriverEntity'
export class AssignDriverModel extends AssignDriverEntity {
  driverId?: number
  constructor(dataDto: AssignDriverEntity) {
    super()
    mapEntityProperties<AssignDriverModel>(this, dataDto, {
      exclude: ['driver'],
      map: {
        driverId: dataDto.driver?.id
      }
    })
  }
}
